import { WithChildrenCommonProps } from '@types';
import { Typography } from '@components/typography';
import { getPageStylesAsClassNames } from './page-styles';

export type IPageProps = WithChildrenCommonProps<{
  selected?: boolean;
  disabled?: boolean;
  selectable?: boolean;
  withIcon?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
}>;

export const Page = ({
  children,
  onClick,
  ariaLabel,
  selected = false,
  disabled = false,
  selectable = true,
  withIcon = false,
}: IPageProps): JSX.Element => (
  <Typography
    bold
    variant="body2"
    component="button"
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled || selected}
    aria-current={selected ? 'step' : undefined}
    className={getPageStylesAsClassNames({
      selected,
      disabled,
      selectable,
      withIcon,
    })}
  >
    {children}
  </Typography>
);
